import { catchError, finalize } from 'rxjs/operators';
// RxJS
import { map } from 'rxjs/operators';
// CRUD
import { BaseDataSource } from '../datasource/base.datasource';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ReferralService } from '../services/referral.service';
import { MatSort } from '@angular/material/sort';

export class MyReferralsDataSource extends BaseDataSource {

	private loadingSubject = new BehaviorSubject<boolean>(false);
	private isPreloadTextViewedSubject = new BehaviorSubject<boolean>(true);

	public loading$ = this.loadingSubject.asObservable();
	public isPreloadTextViewed$ = this.isPreloadTextViewedSubject.asObservable();

	public noRecords = new BehaviorSubject<boolean>(false);
	public noRecords$ = this.noRecords.asObservable();

	constructor(private myreferralsService: ReferralService) {
		super();
	}
	loadMyreferral(refferalFilterList ,referralCode ) {
		this.loadingSubject.next(true);

		this.myreferralsService.getReferral(refferalFilterList, referralCode)
			.pipe(
				map(
					myreferral => {
						if (myreferral.data == null) {
							this.noRecords.next(true);
							this.paginatorTotalSubject.next(myreferral);
							this.entitySubject.next(myreferral);
						} else {
							this.paginatorTotalSubject.next(myreferral.data.TotalRecords);
							this.entitySubject.next(myreferral.data.Items);
							this.noRecords.next(false)
						}
					}
				),
				catchError(() => of([])),
				finalize(() => {
					this.loadingSubject.next(false);
					this.isPreloadTextViewedSubject.next(false);
				})
			)
			.subscribe();
	}
}